<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Import Form
      <div slot="right" class="navbar-message button-gap-right-aligned">
        <b-button class="is-normal import-button" @click="routeToImport">
          &nbsp;&nbsp;Cancel &nbsp;&nbsp;</b-button
        >
        <!-- <b-button type="is-primary import-button" @click="submit">
          &nbsp;&nbsp;&nbsp;Save &nbsp;&nbsp;</b-button
        >-->
        <b-button
          type="is-primary import-button"
          @click.prevent="isnewDataFileListActiveMethod"
          v-if="isEditAllowed"
        >
          &nbsp;&nbsp;&nbsp;Save &nbsp;&nbsp;
        </b-button>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <b-loading
        :is-full-page="true"
        v-model="isDataLoading"
        :can-cancel="true"
      ></b-loading>
      <form @submit.prevent="submit" v-if="isEditAllowed">
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Customer">
              <div>
                <multiselect
                  :value="customers.id"
                  v-model="form.customer"
                  :options="customers"
                  placeholder="Please select a customer"
                  label="name"
                  track-by="name"
                  :searchable="true"
                  @input="updateImportTypeOptions"
                  required
                ></multiselect>
              </div>
            </b-field>
            <b-field label="Import Type">
              <multiselect
                :value="importTypes.name"
                v-model="form.importType"
                :options="availableImportTypes"
                placeholder="Please select a type"
                label="name"
                track-by="name"
                :searchable="false"
                @input="togglePeriod"
                required
              ></multiselect>
            </b-field>
            <b-field label="Period" v-if="showPeriod">
              <b-input
                v-model="form.period"
                name="period"
                required
                maxlength="14"
              />
            </b-field>
            <!-- <b-field v-if="showPeriod"> -->
            <b-checkbox
              v-if="showPeriod"
              id="replaceTDCheckboxId"
              v-model="form.isReplacedTD"
              name="replaceTDCheckbox"
              value="true"
              @click.native="getReplacedTDVal"
            >
              {{ showReplaceImportCheckbox }}
            </b-checkbox>
            <!-- </b-field> -->
            <b-checkbox
              v-if="showPeriod"
              id="addTDMoreCheckboxId"
              v-model="form.isAddedMoreTD"
              name="addTDMoreCheckboxId"
              value="true"
              @click.native="getisAddedMoreTD"
            >
              {{ showAddMoreImportCheckbox }}
            </b-checkbox>
            <section>
              <b-field
                label="Choose a document to attach (CSV, XLSX or XLS)*"
              ></b-field>
              <b-field required class="file is-primary">
                <b-upload
                  required
                  v-model="form.document"
                  class="file-label"
                  multiple
                  drag-drop
                >
                  <span>
                    <section class="section">
                      <div class="content has-text-centered">
                        <p>
                          <b-icon icon="upload" size="is-large"> </b-icon>
                        </p>
                        <p>Drop your files here or click to upload</p>
                      </div>
                    </section>
                  </span>
                </b-upload>
              </b-field>
              <div class="tags">
                <span
                  v-for="(file, index) in form.document"
                  :key="index"
                  class="tag is-primary"
                >
                  {{ file.name }}
                  <button
                    class="delete is-small"
                    type="button"
                    @click="deleteFile(index)"
                  ></button>
                </span>
              </div>
            </section>
            <b-field label="Comments">
              <b-input type="textarea" v-model="form.comments" />
            </b-field>
          </div>
          <div class="column"></div>
        </div>
        <div class="columns"></div>
        <b-modal v-model="isnewDataFileListActive" has-modal-card>
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title title-success">Confirmation</p>
            </header>
            <section class="modal-card-body">
              <div class="columns no-margin-bottom">
                <b-field required class="file is-primary">
                  <div class="content has-text-centered">
                    <span>
                      There is already approved data in TD actual table for this
                      period and customer. Would you like to delete all former
                      records and replace with your new import?"
                    </span>
                  </div>
                </b-field>
              </div>
            </section>
          </div>
          <footer class="modal-card-foot">
            <b-button
              label="Apply"
              type="is-primary"
              @click="submit"
              v-if="isEditAllowed"
            />
            <b-button
              label="Cancel"
              class="is-normal"
              @click="isnewDataFileListActive = false"
            />
          </footer>
        </b-modal>
      </form>
    </section>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import DataManagementService from "../../services/DataManagementImportService";
import Multiselect from "vue-multiselect";
import { UserGroup } from "@/services/UserGroups";
import { mapGetters } from "vuex";
export default {
  name: "DataManagementImportForm",
  components: { HeroBar, TitleBar, Multiselect },
  data() {
    return {
      isRawData: this.$route.params.isRawData,
      isDataLoading: false,
      isnewDataFileListActive: false,
      showReplaceImportCheckbox: "Replace Existing Data",
      showAddMoreImportCheckbox: "Add To Existing Data",
      isReplacedTD: false,
      isAddedMoreTD: false,
      customers: [],
      form: this.getClearFormObject(),
      customerDataService: new CustomerProfileDataService(),
      DataManagementService: new DataManagementService(),
      importTypes: [
        { id: "1", name: "Products" },
        { id: "2", name: "Transactions" }
      ],
      showPeriod: false
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"]),
    availableImportTypes() {
      // If customer with id 0 is selected, show only "Products" option
      if (this.form.customer && this.form.customer.id === 0) {
        return this.importTypes.filter(type => type.name === "Products");
      }
      // Otherwise show all import types
      return this.importTypes;
    },
    isEditAllowed() {
      if (
        this.userGroups.includes(UserGroup.EPR_ADMIN) ||
        // this.userGroups.includes(UserGroup.REPORTING_RESPONSIBLE) ||
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      } else {
        return false;
      }
    },
    titleStack() {
      return [
        { url: "#", name: "Data Management" },
        { url: "/datamangement/import", name: "Import" }
      ];
    }
  },
  mounted() {
    this.fetchCustomerData();
    if (this.$route.params.customer) {
      this.form.customer = this.$route.params.customer;
      // If customer id is 0, automatically update import type options
      if (this.form.customer.id === 0) {
        this.updateImportTypeOptions(this.form.customer);
      }
    }
    if (this.$route.params.importType) {
      // Check if the importType is valid for this customer
      if (
        this.form.customer &&
        this.form.customer.id === 0 &&
        this.$route.params.importType.name !== "Products"
      ) {
        // If customer is id 0, only allow Products
        this.form.importType = this.importTypes.find(
          type => type.name === "Products"
        );
      } else {
        this.form.importType = this.$route.params.importType;
      }
      this.togglePeriod(this.form.importType);
    }
  },
  methods: {
    updateImportTypeOptions(selectedCustomer) {
      // When changing customers, always update import type
      if (selectedCustomer) {
        if (selectedCustomer.id === 0) {
          // If customer with id 0 is selected, set import type to Products only
          // and automatically select it
          this.form.importType = this.importTypes.find(
            type => type.name === "Products"
          );
          // Force togglePeriod to update UI
          this.togglePeriod(this.form.importType);
        } else {
          // Reset import type when changing to other customers
          this.form.importType = null;
        }
      }
    },
    getReplacedTDVal() {
      this.isReplacedTD = false;
    },
    getisAddedMoreTD() {
      this.isAddedMoreTD = false;
    },
    isnewDataFileListActiveMethod() {
      if (this.form.isReplacedTD == true) {
        this.isnewDataFileListActive = true;
      } else {
        this.isnewDataFileListActive = false;
        this.submit();
      }
    },
    getClearFormObject() {
      return {
        customer: null,
        importType: null,
        period: null,
        isReplacedTD: null,
        isAddedMoreTD: null,
        document: null,
        comments: null
      };
    },
    nameWithLang({ name, language }) {
      return `${name} — [${language}]`;
    },
    routeToImport() {
      if (this.isRawData) {
        this.$router.push({ name: "datamanagement.importRawData" });
      } else {
        this.$router.push({ name: "datamanagement.import" });
      }
    },
    fetchCustomerData() {
      this.isDataLoading = true;
      this.customerDataService.getCustomerListForImport().subscribe(
        response => {
          this.customers = response;
          this.isDataLoading = false;
        },
        e => {
          console.log(e);
        }
      );
    },
    submit() {
      this.isDataLoading = true;
      if (!this.form.customer) {
        this.$buefy.toast.open({
          message: "Please select a customer!",
          type: "is-danger"
        });
        this.isDataLoading = false;
      } else if (!this.form.importType) {
        this.$buefy.toast.open({
          message: "Please select Import Type!",
          type: "is-danger"
        });
        this.isDataLoading = false;
      } else {
        this.DataManagementService.create(this.form, this.isRawData).subscribe(
          () => {
            this.isDataLoading = false;
            this.$buefy.dialog.alert({
              title: "Success",
              message:
                "Import triggered successfully. Please refresh list view to see status changes.",
              onConfirm: this.routeToImport()
            });
          },
          this.handleApiError
        );
      }
    },
    togglePeriod(value) {
      if (value.name == "Transactions") {
        this.showPeriod = true;
      } else {
        this.showPeriod = false;
      }
    },
    deleteFile(index) {
      this.form.document.splice(index, 1);
    },
    handleApiError(reason) {
      this.isDataLoading = false;
      let errorMessage = [];
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        } else {
          errorMessage = "An error occurred";
        }
      }
      if (
        reason.response.status == 403 &&
        reason.response.data.code == "token_not_valid"
      ) {
        alert("Session expired, please login again");
        this.authService.logout(this.$keycloak);
        return;
      }

      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
